import Common from "../../../Common";

export interface PbxQueueSBR {
	id?: number
	name: string
	description?: string
	ast_queue_id: id
	weight: number | string
	pbx_destination_id: id
}

export type PbxQueueSBRRead = PbxQueueSBR & {
	src_pbx_destination_id: id
}

const QueueSkill = class extends Common {
	browse = (companyId: id): CustomResponse<PbxQueueSBR[]> =>
		this.get(`/company/${companyId}/pbx/queueskill`)

	read = (companyId: id, id: id): CustomResponse<PbxQueueSBRRead> =>
		this.get(`/company/${companyId}/pbx/queueskill/${id}`)

	create = (companyId: id, data: any, options?: DadExtraOptions) =>
		this.post(`/company/${companyId}/pbx/queueskill${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data)

	update = (companyId: id, id: id, data: any, options?: DadExtraOptions) =>
		this.patch(`/company/${companyId}/pbx/queueskill/${id}${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/queueskill/${id}`)
}

export default QueueSkill
